var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChalkwidettx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 24,
    viewBox: "0 0 143 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4497 16.1052C16.7564 16.3954 16.7871 16.8768 16.4947 17.1813C14.6898 19.0604 12.4081 19.9999 9.6495 19.9999C8.28442 19.9999 7.0132 19.7525 5.83582 19.2577C4.65844 18.7628 3.63463 18.0888 2.7644 17.2356C1.91123 16.3654 1.23722 15.3501 0.742382 14.1898C0.247542 13.0295 0.00012207 11.7753 0.00012207 10.4273C0.00012207 9.07931 0.247542 7.82515 0.742382 6.66484C1.23722 5.50452 1.91123 4.49778 2.7644 3.64461C3.63463 2.77437 4.65844 2.09184 5.83582 1.597C7.0132 1.10216 8.28442 0.854736 9.6495 0.854736C11.1511 0.854736 12.4479 1.11069 13.54 1.62259C14.4282 2.03257 15.2509 2.5903 16.0078 3.29579C16.3259 3.59222 16.3112 4.09154 15.9995 4.39465L14.3747 5.97468C14.0462 6.29418 13.5196 6.26818 13.172 5.96946C12.835 5.67978 12.4628 5.42526 12.0554 5.20591C11.39 4.83052 10.5965 4.64282 9.67509 4.64282C8.87311 4.64282 8.12232 4.77933 7.42272 5.05234C6.74018 5.32536 6.14296 5.71782 5.63106 6.22972C5.11915 6.74162 4.71816 7.35591 4.42808 8.07257C4.13801 8.77217 3.99297 9.55709 3.99297 10.4273C3.99297 11.2976 4.13801 12.091 4.42808 12.8077C4.71816 13.5073 5.11915 14.113 5.63106 14.6249C6.14296 15.1368 6.74018 15.5293 7.42272 15.8023C8.12232 16.0753 8.87311 16.2118 9.67509 16.2118C10.6477 16.2118 11.4923 16.0156 12.209 15.6231C12.6957 15.3566 13.1509 15.0114 13.5747 14.5875C13.9067 14.2553 14.448 14.2117 14.7892 14.5345L16.4497 16.1052Z",
    fill: "#3C45FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3742 5.56432C29.0123 5.56432 30.3261 6.11035 31.3158 7.20241C32.3055 8.2774 32.8003 9.76192 32.8003 11.656V19.2001C32.8003 19.6419 32.4422 20 32.0005 20H29.249C28.8073 20 28.4492 19.6419 28.4492 19.2001V12.2447C28.4492 11.2891 28.2017 10.5468 27.7069 10.0179C27.2121 9.48891 26.5466 9.22443 25.7105 9.22443C24.8744 9.22443 24.2089 9.48891 23.7141 10.0179C23.2192 10.5468 22.9718 11.2891 22.9718 12.2447V19.2001C22.9718 19.6419 22.6137 20 22.172 20H19.3949C18.9531 20 18.595 19.6419 18.595 19.2001V1.85942C18.595 1.41767 18.9531 1.05957 19.3949 1.05957H22.172C22.6137 1.05957 22.9718 1.41767 22.9718 1.85942V7.63752C23.4155 7.00618 24.0212 6.50281 24.7891 6.12741C25.5569 5.75202 26.4186 5.56432 27.3742 5.56432Z",
    fill: "#3C45FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 12.1906C34.4 10.7231 34.673 9.43483 35.2191 8.32571C35.7822 7.21658 36.5415 6.36341 37.497 5.76619C38.4526 5.16897 39.5191 4.87036 40.6964 4.87036C41.7032 4.87036 42.5819 5.07512 43.3327 5.48464C44.1006 5.89417 44.6893 6.43167 45.0988 7.09714V5.87497C45.0988 5.43323 45.4569 5.07512 45.8986 5.07512H48.6757C49.1175 5.07512 49.4756 5.43323 49.4756 5.87497V19.2C49.4756 19.6418 49.1175 19.9999 48.6757 19.9999H45.8986C45.4569 19.9999 45.0988 19.6418 45.0988 19.2V17.3352C44.6722 18.0007 44.075 18.5382 43.3071 18.9477C42.5563 19.3572 41.6776 19.562 40.6708 19.562C39.5105 19.562 38.4526 19.2634 37.497 18.6662C36.5415 18.0519 35.7822 17.1902 35.2191 16.081C34.673 14.9549 34.4 13.658 34.4 12.1906ZM45.0988 12.2162C45.0988 11.1241 44.7917 10.2624 44.1774 9.63106C43.5802 8.99971 42.8464 8.68404 41.9762 8.68404C41.106 8.68404 40.3637 8.99971 39.7494 9.63106C39.1522 10.2453 38.8536 11.0985 38.8536 12.1906C38.8536 13.2826 39.1522 14.1529 39.7494 14.8013C40.3637 15.4326 41.106 15.7483 41.9762 15.7483C42.8464 15.7483 43.5802 15.4326 44.1774 14.8013C44.7917 14.1699 45.0988 13.3082 45.0988 12.2162Z",
    fill: "#3C45FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0616 20.3026C51.5534 20.3026 51.174 19.8348 51.279 19.3376L54.6937 3.15768C54.9152 2.10828 55.9366 1.4298 56.9898 1.63247V1.63247C58.0333 1.83329 58.7286 2.82668 58.56 3.87588L56.0283 19.6297C55.966 20.0175 55.6313 20.3026 55.2386 20.3026L52.0616 20.3026Z",
    fill: "#3C45FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0225 2.47368C61.0225 2.03193 61.3806 1.67383 61.8224 1.67383H64.0619C64.5037 1.67383 64.8618 2.03193 64.8618 2.47368V10.9905H65.1177L67.7311 8.41446C68.3526 7.80179 69.1903 7.45833 70.0631 7.45833H73.129C73.2704 7.45833 73.385 7.57293 73.385 7.71428V7.71428L68.8546 12.0655L73.8457 19.744V19.744C73.8457 19.8854 73.7311 20 73.5897 20H69.7923C69.5122 20 69.2524 19.8534 69.1076 19.6136L66.1416 14.7018L64.8618 15.9303V19.2001C64.8618 19.6419 64.5037 20 64.0619 20H61.8224C61.3806 20 61.0225 19.6419 61.0225 19.2001V2.47368Z",
    fill: "#3C45FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6535 0.803711C98.1621 0.803711 98.5415 1.27221 98.4359 1.76975L94.5636 20.0001H89.46L87.0837 7.54652L84.6265 20.0001H79.5499L75.6522 1.7708C75.5458 1.27298 75.9253 0.803711 76.4344 0.803711H79.3778C79.7721 0.803711 80.1076 1.09109 80.1682 1.48073L82.1962 14.5301L84.6135 1.45812C84.6836 1.0789 85.0143 0.803711 85.4 0.803711H88.9584C89.3432 0.803711 89.6735 1.07772 89.7445 1.45591L92.1873 14.4613L94.189 1.48165C94.2492 1.09159 94.5848 0.803711 94.9795 0.803711H97.6535Z",
    fill: "#3C45FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.387 5.21374C102.046 5.21374 101.73 5.15402 101.44 5.03458C101.15 4.89807 100.894 4.72744 100.672 4.52268C100.468 4.30085 100.297 4.0449 100.16 3.75482C100.041 3.46474 99.9812 3.14907 99.9812 2.8078C99.9812 2.4836 100.041 2.17645 100.16 1.88637C100.297 1.57923 100.468 1.32328 100.672 1.11852C100.894 0.896696 101.15 0.726062 101.44 0.606617C101.73 0.470109 102.046 0.401855 102.387 0.401855C102.711 0.401855 103.018 0.470109 103.309 0.606617C103.616 0.726062 103.872 0.896696 104.076 1.11852C104.298 1.32328 104.469 1.57923 104.588 1.88637C104.725 2.17645 104.793 2.4836 104.793 2.8078C104.793 3.14907 104.725 3.46474 104.588 3.75482C104.469 4.0449 104.298 4.30085 104.076 4.52268C103.872 4.72744 103.616 4.89807 103.309 5.03458C103.018 5.15402 102.711 5.21374 102.387 5.21374Z",
    fill: "#3C45FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.418 20.0263C100.976 20.0263 100.618 19.6682 100.618 19.2264V7.3958C100.618 6.95405 100.976 6.59595 101.418 6.59595H103.657C104.099 6.59595 104.457 6.95405 104.457 7.3958V19.2264C104.457 19.6681 104.099 20.0263 103.657 20.0263H101.418Z",
    fill: "#3C45FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.652 12.5775C106.652 11.11 106.925 9.82174 107.471 8.71261C108.035 7.60349 108.794 6.75032 109.749 6.1531C110.705 5.55588 111.771 5.25727 112.949 5.25727C113.887 5.25727 114.74 5.4535 115.508 5.84596C116.293 6.23841 116.908 6.76738 117.351 7.43286V1.60356C117.351 1.16181 117.709 0.803711 118.151 0.803711H120.928C121.37 0.803711 121.728 1.16182 121.728 1.60356V19.2002C121.728 19.642 121.37 20.0001 120.928 20.0001H118.151C117.709 20.0001 117.351 19.642 117.351 19.2002V17.6965C116.942 18.3791 116.353 18.9251 115.585 19.3346C114.834 19.7441 113.956 19.9489 112.949 19.9489C111.771 19.9489 110.705 19.6503 109.749 19.0531C108.794 18.4388 108.035 17.5771 107.471 16.4679C106.925 15.3418 106.652 14.0449 106.652 12.5775ZM117.351 12.6031C117.351 11.511 117.044 10.6493 116.43 10.018C115.833 9.38662 115.099 9.07095 114.229 9.07095C113.358 9.07095 112.616 9.38662 112.002 10.018C111.405 10.6323 111.106 11.4854 111.106 12.5775C111.106 13.6695 111.405 14.5398 112.002 15.1882C112.616 15.8195 113.358 16.1352 114.229 16.1352C115.099 16.1352 115.833 15.8195 116.43 15.1882C117.044 14.5568 117.351 13.6951 117.351 12.6031Z",
    fill: "#3C45FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.661 12.7121C137.661 12.8985 137.656 13.0883 137.645 13.2817C137.623 13.6874 137.277 13.9919 136.871 13.9919H127.679C127.747 14.8792 128.029 15.5617 128.523 16.0395C129.035 16.5002 129.658 16.7306 130.392 16.7306C131.292 16.7306 131.967 16.4173 132.415 15.7906C132.596 15.5371 132.869 15.3484 133.181 15.3484H136.299C136.821 15.3484 137.204 15.8427 136.996 16.3211C136.752 16.8801 136.428 17.4006 136.023 17.8824C135.408 18.6331 134.632 19.2218 133.694 19.6484C132.755 20.075 131.655 19.994 130.494 19.994C129.095 19.994 127.901 19.9897 126.809 19.3925C125.716 18.7952 124.863 17.9421 124.249 16.833C123.635 15.7238 123.328 14.427 123.328 12.9425C123.328 11.458 123.626 10.1611 124.223 9.05203C124.838 7.9429 125.691 7.08973 126.783 6.49251C127.875 5.89529 129.129 5.59668 130.545 5.59668C131.928 5.59668 133.156 5.88676 134.231 6.46692C135.306 7.04707 136.142 7.87465 136.739 8.94965C137.354 10.0246 137.661 11.2788 137.661 12.7121ZM133.182 11.5604C133.182 10.8096 132.926 10.2123 132.414 9.76869C131.902 9.32504 131.262 9.10322 130.494 9.10322C129.76 9.10322 129.138 9.31651 128.626 9.7431C128.131 10.1697 127.824 10.7754 127.704 11.5604H133.182Z",
    fill: "#3C45FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 21.25C52.5 21.3881 52.3881 21.5 52.25 21.5C52.1119 21.5 52 21.3881 52 21.25C52 21.1119 52.1119 21 52.25 21C52.3881 21 52.5 21.1119 52.5 21.25Z",
    fill: "url(#paint0_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 22.25C53.5 22.3881 53.3881 22.5 53.25 22.5C53.1119 22.5 53 22.3881 53 22.25C53 22.1119 53.1119 22 53.25 22C53.3881 22 53.5 22.1119 53.5 22.25Z",
    fill: "url(#paint1_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 22.25C54.5 22.3881 54.3881 22.5 54.25 22.5C54.1119 22.5 54 22.3881 54 22.25C54 22.1119 54.1119 22 54.25 22C54.3881 22 54.5 22.1119 54.5 22.25Z",
    fill: "url(#paint2_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 23.25C56.5 23.3881 56.3881 23.5 56.25 23.5C56.1119 23.5 56 23.3881 56 23.25C56 23.1119 56.1119 23 56.25 23C56.3881 23 56.5 23.1119 56.5 23.25Z",
    fill: "url(#paint3_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 23.25C54.5 23.3881 54.3881 23.5 54.25 23.5C54.1119 23.5 54 23.3881 54 23.25C54 23.1119 54.1119 23 54.25 23C54.3881 23 54.5 23.1119 54.5 23.25Z",
    fill: "url(#paint4_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 21.25C54.5 21.3881 54.3881 21.5 54.25 21.5C54.1119 21.5 54 21.3881 54 21.25C54 21.1119 54.1119 21 54.25 21C54.3881 21 54.5 21.1119 54.5 21.25Z",
    fill: "url(#paint5_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 22.25C55.5 22.3881 55.3881 22.5 55.25 22.5C55.1119 22.5 55 22.3881 55 22.25C55 22.1119 55.1119 22 55.25 22C55.3881 22 55.5 22.1119 55.5 22.25Z",
    fill: "url(#paint6_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 22.25C57.5 22.3881 57.3881 22.5 57.25 22.5C57.1119 22.5 57 22.3881 57 22.25C57 22.1119 57.1119 22 57.25 22C57.3881 22 57.5 22.1119 57.5 22.25Z",
    fill: "url(#paint7_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 22.25C60.5 22.3881 60.3881 22.5 60.25 22.5C60.1119 22.5 60 22.3881 60 22.25C60 22.1119 60.1119 22 60.25 22C60.3881 22 60.5 22.1119 60.5 22.25Z",
    fill: "url(#paint8_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 22.25C62.5 22.3881 62.3881 22.5 62.25 22.5C62.1119 22.5 62 22.3881 62 22.25C62 22.1119 62.1119 22 62.25 22C62.3881 22 62.5 22.1119 62.5 22.25Z",
    fill: "url(#paint9_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5 22.25C64.5 22.3881 64.3881 22.5 64.25 22.5C64.1119 22.5 64 22.3881 64 22.25C64 22.1119 64.1119 22 64.25 22C64.3881 22 64.5 22.1119 64.5 22.25Z",
    fill: "url(#paint10_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 23.25C62.5 23.3881 62.3881 23.5 62.25 23.5C62.1119 23.5 62 23.3881 62 23.25C62 23.1119 62.1119 23 62.25 23C62.3881 23 62.5 23.1119 62.5 23.25Z",
    fill: "url(#paint11_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 22.25C66.5 22.3881 66.3881 22.5 66.25 22.5C66.1119 22.5 66 22.3881 66 22.25C66 22.1119 66.1119 22 66.25 22C66.3881 22 66.5 22.1119 66.5 22.25Z",
    fill: "url(#paint12_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 22.25C68.5 22.3881 68.3881 22.5 68.25 22.5C68.1119 22.5 68 22.3881 68 22.25C68 22.1119 68.1119 22 68.25 22C68.3881 22 68.5 22.1119 68.5 22.25Z",
    fill: "url(#paint13_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 23.25C61.5 23.3881 61.3881 23.5 61.25 23.5C61.1119 23.5 61 23.3881 61 23.25C61 23.1119 61.1119 23 61.25 23C61.3881 23 61.5 23.1119 61.5 23.25Z",
    fill: "url(#paint14_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 23.25C57.5 23.3881 57.3881 23.5 57.25 23.5C57.1119 23.5 57 23.3881 57 23.25C57 23.1119 57.1119 23 57.25 23C57.3881 23 57.5 23.1119 57.5 23.25Z",
    fill: "url(#paint15_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 23.25C59.5 23.3881 59.3881 23.5 59.25 23.5C59.1119 23.5 59 23.3881 59 23.25C59 23.1119 59.1119 23 59.25 23C59.3881 23 59.5 23.1119 59.5 23.25Z",
    fill: "url(#paint16_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 22.25C58.5 22.3881 58.3881 22.5 58.25 22.5C58.1119 22.5 58 22.3881 58 22.25C58 22.1119 58.1119 22 58.25 22C58.3881 22 58.5 22.1119 58.5 22.25Z",
    fill: "url(#paint17_linear_55966_21847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 22.25C51.5 22.3881 51.3881 22.5 51.25 22.5C51.1119 22.5 51 22.3881 51 22.25C51 22.1119 51.1119 22 51.25 22C51.3881 22 51.5 22.1119 51.5 22.25Z",
    fill: "url(#paint18_linear_55966_21847)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_55966_21847",
    x1: 51,
    y1: 22.25,
    x2: 68.5,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#1134FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkwidettx);
export default __webpack_public_path__ + "static/media/chalkwidettx.876967482bf7065bcb607573411d8a62.svg";
export { ForwardRef as ReactComponent };